import { AnalyticsEvent } from '@/lib/analytics/Analytics.constants'
import { buildCollectionPayload, gtm } from '@/lib/analytics/Analytics.utils'
import { toStorefrontProductFromHit, useAnalyzifyTracking, VIEW_STAGE_PRICE } from '@/lib/analyzify'

import { ProductCard } from '../ProductCard/ProductCard'

import type { BaseHit, Hit } from 'instantsearch.js'

export const AlgoliaProductCard = ({
  hit,
  collectionHandle,
  collectionId,
  listName,
}: {
  hit: Hit<BaseHit>
  collectionHandle?: string
  collectionId?: string
  /** Title shoppers see for the list this card sits in. */
  listName?: string
}) => {
  const { selectItem } = useAnalyzifyTracking()
  const image = hit.image ? { url: hit.image as string, altText: hit.title as string } : undefined
  const collectionTitle = hit.product_type
  const href = hit.handle ? `/products/${hit.handle}` : '#'
  const title = hit.title

  const onClick = () => {
    const payload = buildCollectionPayload({ items: [hit], collectionId, collectionHandle })
    gtm.push(AnalyticsEvent.PRODUCT_SELECTED, payload)
    const index = typeof hit.__position === 'number' ? hit.__position - 1 : undefined
    // Same list name and id as the view_item_list this click came from, so the
    // product is attributed to the list rather than to the landing page.
    selectItem(toStorefrontProductFromHit(hit, VIEW_STAGE_PRICE), listName || collectionHandle || '', index, collectionId)
  }

  return <ProductCard title={title} collection={collectionTitle} image={image} link={href} onClick={onClick} />
}
